import { render, staticRenderFns } from "./cabinet-fl223-proposal-card.vue?vue&type=template&id=0d90545e&scoped=true&"
import script from "./cabinet-fl223-proposal-card.vue?vue&type=script&lang=js&"
export * from "./cabinet-fl223-proposal-card.vue?vue&type=script&lang=js&"
import style0 from "./cabinet-fl223-proposal-card.vue?vue&type=style&index=0&id=0d90545e&scoped=true&lang=css&"
import style1 from "./cabinet-fl223-proposal-card.vue?vue&type=style&index=1&id=0d90545e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d90545e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev3/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0d90545e')) {
      api.createRecord('0d90545e', component.options)
    } else {
      api.reload('0d90545e', component.options)
    }
    module.hot.accept("./cabinet-fl223-proposal-card.vue?vue&type=template&id=0d90545e&scoped=true&", function () {
      api.rerender('0d90545e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/cabinet/fl223/cards/cabinet-fl223-proposal-card.vue"
export default component.exports